/*
 * ⭐ ARTIST FREE-CARD MODE ON THE PAGES WHERE CARDS ARE CHOSEN (14 Oct).
 *
 * An artist's "Send a free card" (artists.picturepops.com) opens /products/picturepop?artist=1, which is builder B since
 * 14 Oct (configurator.js ARTIST_TOKEN, noOldEntry). With a design (&design=<art key>) B opens on it. Without one, B
 * has no screen where a card is chosen, so it sends the artist where customers choose one, All cards, with
 * ?artistcard=1 (configurator.js oldEntryAway). This file keeps that mode for the tab (sessionStorage) and does three
 * things on every page of the site's own layout:
 *
 *   1. Every link into the builder opens in artist mode: ?artist=1 added at the click (any link, any page: the
 *      design lightbox's "Design this card", a design's own page, the nav). &new and &claim go (the artist builder keeps
 *      no draft and takes no claim).
 *   2. A bar at the top of the page says so, with the cards left, and the way out (Back to my designs, which ends it).
 *   3. The artist's own designs lead the grid (Daniel, 2026-09-17: "the artist's own designs lead every grid"): on a card
 *      list (All cards, an occasion's page, a series') a "Your designs" row sits above the cards, each opening the builder
 *      on that design. They come from the artist platform, as the builder's do (GET /api/free-cards/designs).
 *
 * ⚠️ ?artistcard=, never ?artist=: on the card list ?artist= is the Artist filter (rd-finding.js PARAM). ?artistcard=0
 * ends the mode. Customers never have it: without the parameter or the tab's flag this file does nothing.
 */
(function () {
  'use strict';
  var KEY = 'pp_artist_mode_v1', P = 'artistcard', ORIGIN = 'https://artists.picturepops.com';
  var q;
  try { q = new URLSearchParams(location.search); } catch (e) { return; }
  var on = q.get(P) === '1';
  try {
    if (q.get(P) === '0') { sessionStorage.removeItem(KEY); return; }
    if (on) sessionStorage.setItem(KEY, '1'); else on = sessionStorage.getItem(KEY) === '1';
  } catch (e) { /* no storage: the address alone carries it */ }
  if (!on) return;
  var end = function () { try { sessionStorage.removeItem(KEY); } catch (e) { /* nothing kept */ } };

  /* ---- 1. builder links open in artist mode ---- */
  function artistHref(raw) {
    var u;
    try { u = new URL(raw, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin || u.pathname !== '/products/picturepop') return null;
    u.searchParams.set('artist', '1');
    u.searchParams.delete('new');
    u.searchParams.delete('claim');
    return u.pathname + u.search + u.hash;
  }
  function onLink(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var h = artistHref(a.getAttribute('href'));
    if (h) a.setAttribute('href', h);
  }
  document.addEventListener('click', onLink, true);
  document.addEventListener('auxclick', onLink, true);
  document.addEventListener('contextmenu', onLink, true);

  /* ---- the look: the site's tokens (rd-shell.css :root). Blue only on the button that acts, green only for the cards
     left (good news), amber for what is still waiting (sign in, terms). ---- */
  var css = '' +
    '.ppam-bar{position:relative;z-index:5;background:var(--surface,#FEFEFF);border-bottom:1px solid var(--line,#DFE1E3);font-family:var(--font-body,system-ui,sans-serif);color:var(--ink,#1B2433)}' +
    '.ppam-bar__in{max-width:1280px;margin:0 auto;padding:12px 32px;display:flex;align-items:center;gap:16px;flex-wrap:wrap}' +
    '.ppam-bar__eyebrow{font:500 12px/1 var(--font-mono,ui-monospace,monospace);letter-spacing:.06em;text-transform:uppercase;color:var(--ink-2,#47526A)}' +
    '.ppam-bar__txt{flex:1 1 320px;min-width:0;display:flex;flex-direction:column;gap:4px}' +
    '.ppam-bar__line{margin:0;font:400 15px/1.45 var(--font-body,system-ui,sans-serif);color:var(--ink-2,#47526A)}' +
    '.ppam-bar__line strong{color:var(--ink,#1B2433);font-weight:600}' +
    '.ppam-pill{display:inline-flex;align-items:center;height:28px;padding:0 12px;border-radius:999px;font:600 13px/1 var(--font-body,system-ui,sans-serif);white-space:nowrap}' +
    '.ppam-pill.is-good{background:var(--success-soft,#E1F0E5);color:var(--success,#2F7A4B)}' +
    '.ppam-pill.is-wait{background:var(--warning-soft,#FBEFD6);color:var(--warning,#9A6200)}' +
    '.ppam-bar__act{display:flex;align-items:center;gap:12px;flex-wrap:wrap}' +
    '.ppam-btn{display:inline-flex;align-items:center;justify-content:center;height:44px;padding:0 18px;border-radius:var(--r-button,12px);font:600 15px/1 var(--font-body,system-ui,sans-serif);text-decoration:none;white-space:nowrap}' +
    '.ppam-btn.is-primary{background:var(--primary,#1F4FA3);color:var(--on-primary,#fff)!important}' +
    '.ppam-btn.is-primary:hover{background:var(--primary-hover,#193F85)}' +
    '.ppam-btn.is-quiet{background:var(--surface,#FEFEFF);color:var(--ink,#1B2433)!important;box-shadow:inset 0 0 0 1px var(--line-2,#C9CBCE)}' +
    '.ppam-own{margin:0 0 32px}' +
    '.ppam-own__h{margin:0 0 4px;font:400 24px/1.2 var(--font-display,Georgia,serif);letter-spacing:var(--display-tracking,-.01em);color:var(--ink,#1B2433)}' +
    '.ppam-own__p{margin:0 0 16px;font:400 15px/1.45 var(--font-body,system-ui,sans-serif);color:var(--ink-2,#47526A)}' +
    '.ppam-own .rdf-grid{margin:0}' +
    '.ppam-own__sep{margin:32px 0 0;border:0;border-top:1px solid var(--line,#DFE1E3)}' +
    '@media (max-width:760px){.ppam-bar__in{padding:12px 16px;gap:12px}.ppam-bar__act{width:100%}.ppam-bar__act .ppam-btn{flex:1}.ppam-own__h{font-size:21px}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var builder = function (key) { return '/products/picturepop?artist=1' + (key ? '&design=' + encodeURIComponent(key) : ''); };

  /* ---- 2. the bar ---- */
  var bar = null;
  function drawBar(state, left) {
    var line, pill = '', act = '';
    var back = '<a class="ppam-btn is-quiet" href="' + ORIGIN + '/designs" data-ppam-end>Back to my designs</a>';
    if (state === 'signin') {
      line = 'Your free cards belong to your artist account. <strong>Sign in</strong>, then come back to choose a card.';
      pill = '<span class="ppam-pill is-wait">Signed out</span>';
      act = '<a class="ppam-btn is-primary" href="' + ORIGIN + '/login">Sign in</a>';
    } else if (state === 'terms') {
      line = 'Please accept the artist terms in your account, then come back to choose a card.';
      pill = '<span class="ppam-pill is-wait">One step first</span>';
      act = '<a class="ppam-btn is-primary" href="' + ORIGIN + '/terms">Open my account</a>';
    } else if (state === 'none') {
      line = 'You’ve sent both of your free cards. Thank you for making something lovely.';
      act = back;
    } else if (state === 'error') {
      line = 'We couldn’t reach your artist account just now. You can still choose a card; we check again when you open it.';
      act = back;
    } else {
      line = 'Choose any card here, or one of your own designs. Then add your photos and send it, on us.';
      if (left > 0) pill = '<span class="ppam-pill is-good">' + (left === 1 ? '1 free card left' : left + ' free cards left') + '</span>';
      act = back;
    }
    var html = '<div class="ppam-bar__in"><div class="ppam-bar__txt"><span class="ppam-bar__eyebrow">Picturepops Artists · Your free card</span>' +
      '<p class="ppam-bar__line">' + line + '</p></div><div class="ppam-bar__act">' + pill + act + '</div></div>';
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'ppam-bar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Your free card');
      var main = document.getElementById('content') || document.querySelector('main');
      if (main && main.parentNode) main.parentNode.insertBefore(bar, main); else document.body.insertBefore(bar, document.body.firstChild);
      bar.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-ppam-end]')) end(); });
    }
    bar.innerHTML = html;
  }

  /* ---- 3. the artist's own designs, above the card list ---- */
  function drawOwn(designs) {
    var results = document.querySelector('[data-rdf-list] .rdf-results');
    if (!results || !designs.length || results.querySelector('.ppam-own')) return;
    var F = window.RDF;
    var tiles = designs.map(function (d) {
      var front = (d.art && d.art.CoverFront) || '';
      var card = F && F.pictureCard ? F.pictureCard(front, { motion: 'tilt', full: true, alt: d.name || '' })
        : '<img src="' + esc(front) + '" alt="' + esc(d.name || '') + '" loading="lazy" style="width:100%;height:auto">';
      return '<li class="rdf-cell"><a class="rdf-tile" href="' + esc(builder(d.artKey || d.id)) + '" aria-label="' + esc((d.name || 'Your design') + ', your design, free') + '">' +
        '<div class="rdf-tile__card">' + card + '</div>' +
        '<div class="rdf-tile__txt"><span class="rdf-tile__name">' + esc(d.name || 'Your design') + '</span><span class="rdf-tile__by">Your design</span>' +
        '<span class="rdf-price"><span>Free</span></span></div></a></li>';
    }).join('');
    var sec = document.createElement('section');
    sec.className = 'ppam-own';
    sec.setAttribute('aria-labelledby', 'ppam-own-h');
    sec.innerHTML = '<h2 class="ppam-own__h" id="ppam-own-h">Your designs</h2><p class="ppam-own__p">Only you can see these. Send one as a free card.</p>' +
      '<ul class="rdf-grid" aria-label="Your designs">' + tiles + '</ul><hr class="ppam-own__sep">';
    results.insertBefore(sec, results.firstChild);
  }

  function start() {
    drawBar('ready', 0);
    fetch(ORIGIN + '/api/free-cards/designs', { credentials: 'include' }).then(function (r) {
      if (r.status === 401) { drawBar('signin'); return null; }
      if (r.status === 403) { drawBar('terms'); return null; }
      if (!r.ok) { drawBar('error'); return null; }
      return r.json();
    }).then(function (j) {
      if (!j) return;
      if (!j.unlocked || !(j.left > 0)) { drawBar('none'); end(); return; }
      drawBar('ready', j.left);
      drawOwn(j.designs || []);
    }).catch(function () { drawBar('error'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
